/**
 * A filter function to remove null/undefined entries from an array. This will fix the return
 * type appropriately. Usage: myArr.filter(notEmpty)
 * @param value - The value to test for emptiness
 */
export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}
